document.addEventListener('DOMContentLoaded', () => {
  // --- Filters code ---
  const filterToggle = document.getElementById('filter-toggle');
  const filtersOverlay = document.getElementById('filters-overlay');
  const filtersClose = document.getElementById('filters-close');
  const filterLinks = document.querySelectorAll('.filter-link');
  const products = document.querySelectorAll('.product-item');

  function applyFilter(type) {
    filterLinks.forEach(link => link.classList.remove('active'));
    const activeLink = Array.from(filterLinks).find(link => link.dataset.type === type);
    if (activeLink) activeLink.classList.add('active');

    products.forEach(product => {
      if (type === 'all' || product.dataset.type === type) {
        product.style.display = '';
      } else {
        product.style.display = 'none';
      }
    });
  }

  filterToggle.addEventListener('click', () => {
    filtersOverlay.classList.add('active');
    filterToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  });

  filtersClose.addEventListener('click', () => {
    filtersOverlay.classList.remove('active');
    filterToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  });

  filtersOverlay.addEventListener('click', e => {
    if (e.target === filtersOverlay) {
      filtersClose.click();
    }
  });

  filterLinks.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const type = e.currentTarget.dataset.type;
      applyFilter(type);
    });
  });

  const urlParams = new URLSearchParams(window.location.search);
  const productTypeFilter = urlParams.get('filter.p.product_type') || 'all';
  applyFilter(productTypeFilter);

  // --- Variant selection and price update ---

  const sizeOptions = document.querySelectorAll('.size-option');
  const selectedVariantInput = document.querySelector('#selected-variant');
  const variantPrice = document.querySelector('#variant-price');

  function formatPrice(price) {
    const num = Number(price);
    if (isNaN(num)) return price;
    // Adjust formatting as needed for your locale/currency
    return (num / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function selectVariant(variantElement) {
    sizeOptions.forEach(el => el.classList.remove('active'));
    variantElement.classList.add('active');

    const variantId = variantElement.dataset.variantId || '';
    const price = variantElement.dataset.price || '';

    if (selectedVariantInput) selectedVariantInput.value = variantId;
    if (variantPrice) variantPrice.textContent = price ? formatPrice(price) : '';

    // Enable add to cart button or other logic here if you want
  }

  // Auto select first available variant
  const firstAvailable = Array.from(sizeOptions).find(el => {
    // Customize condition: e.g. data-available="true" or no .disabled class
    return el.dataset.available === "true" && !el.classList.contains('disabled');
  });

  if (firstAvailable) {
    selectVariant(firstAvailable);
  }

  // Add click listeners for manual selection
  sizeOptions.forEach(option => {
    option.addEventListener('click', () => {
      if (option.dataset.available === "true" && !option.classList.contains('disabled')) {
        selectVariant(option);
      }
    });
  });

});

document.addEventListener('DOMContentLoaded', () => {
  // --- Swiper for highlighted products ---
  var swiperCollection = new Swiper(".highlighted-product-items", {
    slidesPerView: 3,
    slidesPerGroup: 3,
    spaceBetween: 3,
    speed: 550,
    grabCursor: true,
    pagination: {
      el: ".slider-pagination",
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      1000: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      }
    },
  });

  // --- Swiper for product images (main slider) ---
  var productImagesSwiper = new Swiper(".product-images", {
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 550,
    direction: 'vertical',
    grabCursor: true,
    mousewheel: true,
    thumbs: {
      swiper: null, // will assign below
    },
    breakpoints: {
      0: {
        direction: 'horizontal',
      },
      1000: {
        direction: 'vertical',
      }
    },
    pagination: {
      el: ".slider-pagination",
      clickable: true,
    },
  });

  // --- Swiper for thumbnails ---
  var productThumbsSwiper = new Swiper(".product-thumbnails", {
    slidesPerView: 4,
    spaceBetween: 8,
    speed: 550,
    direction: 'vertical',
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    mousewheel: true,
  });

  // Link thumbs to main images
  productImagesSwiper.thumbs.swiper = productThumbsSwiper;
  productImagesSwiper.thumbs.init();
  productImagesSwiper.thumbs.update();

  // Update total slides count with leading zero
  const totalSlidesCount = productImagesSwiper.slides.length;
  document.querySelectorAll('.total-slides-count').forEach(el => {
    el.textContent = '/0' + totalSlidesCount;
  });
});

const items = document.querySelectorAll('.accordion-item');

items.forEach(item => {
  const header = item.querySelector('.accordion-header');
  const content = item.querySelector('.accordion-content');

  header.addEventListener('click', () => {
    const isActive = item.classList.contains('active');

    // Close all open accordions
    items.forEach(i => {
      i.classList.remove('active');
      const c = i.querySelector('.accordion-content');
      c.style.maxHeight = null;
      c.style.opacity = 0;
    });

    // If not already open, open the clicked one
    if (!isActive) {
      item.classList.add('active');
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.opacity = 1;
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const sizeGuideBtn = document.getElementById('open-size-guide');
  const sizeGuidePopup = document.getElementById('size-guide-popup');

  if (sizeGuideBtn && sizeGuidePopup) {
    sizeGuideBtn.addEventListener('click', () => {
      sizeGuidePopup.classList.add('active');
      document.body.style.overflow = 'hidden';
    });

    sizeGuidePopup.addEventListener('click', (e) => {
      if (e.target === sizeGuidePopup) {
        sizeGuidePopup.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname.includes('/cart')) {
    document.querySelectorAll('.size-option').forEach(option => {
      option.addEventListener('click', function () {
        const variantId = this.getAttribute('data-variant-id');
        const lineItemKey = this.getAttribute('data-line-item-key');

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: lineItemKey,
            quantity: 0
          })
        }).then(() => {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });
        }).then(() => {
          location.reload();
        });
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const svgPlus =
    "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='butt' aria-hidden='true' focusable='false' style='width:100%;height:100%;display:block'>\
      <line x1='12' y1='5' x2='12' y2='19'/><line x1='5' y1='12' x2='19' y2='12'/>\
    </svg>";
  const svgMinus =
    "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='butt' aria-hidden='true' focusable='false' style='width:100%;height:100%;display:block'>\
      <line x1='5' y1='12' x2='19' y2='12'/>\
    </svg>";

  const scope = document.querySelector('.info-page');
  if (!scope) return;

  const toggles = scope.querySelectorAll('.accordion-faq-toggle');
  const panels  = scope.querySelectorAll('.accordion-faq-content');

  // Ensure icon span exists, force visible size, set initial icon
  toggles.forEach(btn => {
    let icon = btn.querySelector('span.faq-icon');
    if (!icon) {
      // Prefer existing trailing span; else create one
      icon = btn.querySelector('span') || document.createElement('span');
      icon.classList.add('faq-icon');
      if (!icon.parentNode) btn.appendChild(icon);
    }
    // Inline sizing to beat any theme rules hiding spans
    icon.style.display = 'inline-flex';
    icon.style.width = '12px';
    icon.style.height = '12px';
    icon.style.marginLeft = '.4em';
    icon.style.verticalAlign = 'middle';
    icon.innerHTML = svgPlus;

    // Remove any leftover text nodes like '+'/'−'
    if (icon.firstChild && icon.firstChild.nodeType === Node.TEXT_NODE) icon.textContent = '';
  });

  // Initialize based on active panel
  toggles.forEach(btn => {
    const id = btn.getAttribute('data-target');
    const panel = id && document.getElementById(id);
    const icon = btn.querySelector('.faq-icon');
    if (panel && panel.classList.contains('active') && icon) icon.innerHTML = svgMinus;
  });

  // Click behavior
  toggles.forEach(btn => {
    btn.addEventListener('click', () => {
      const id = btn.getAttribute('data-target');
      const panel = id && document.getElementById(id);
      if (!panel) return;

      const wasActive = panel.classList.contains('active');

      // Close all panels and reset icons
      panels.forEach(p => p.classList.remove('active'));
      toggles.forEach(t => {
        const i = t.querySelector('.faq-icon');
        if (i) i.innerHTML = svgPlus;
        t.classList.remove('selected');
      });

      // Open clicked
      if (!wasActive) {
        panel.classList.add('active');
        const i = btn.querySelector('.faq-icon');
        if (i) i.innerHTML = svgMinus;
        btn.classList.add('selected');
      }
    });
  });
});